import { render, staticRenderFns } from "./Sdk.vue?vue&type=template&id=00e7bd10&scoped=true"
import script from "./Sdk.vue?vue&type=script&lang=js"
export * from "./Sdk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e7bd10",
  null
  
)

export default component.exports